module.exports = __webpack_public_path__ + "img/kommune-1145.8fdedd64.svg";